import { useCallback, MouseEvent, ReactElement } from "react";

export function ProceedToPaymentButton({
  onPaymentRequested,
  labelText,
}: {
  onPaymentRequested: () => void;
  labelText: string;
}): ReactElement {
  const handleClick = useCallback(
    (event: MouseEvent<HTMLInputElement>) => {
      event.preventDefault();
      onPaymentRequested();
    },
    [onPaymentRequested]
  );

  return <input type="submit" onClick={handleClick} value={labelText} />;
}
